@if (membros().length && reunioes().length) {
    <div class="matriz-wrapper">
        <div class="matriz-scroll">
            <table class="matriz-tabela">
                <thead>
                    <tr>
                        <th class="col-membro col-sticky">Membro</th>
                        @for (reuniao of reunioes(); track reuniao.idReuniao) {
                            <th class="col-reuniao" [title]="reuniao.dhInicioReuniao">{{ formatarData(reuniao.dhInicioReuniao) }}</th>
                        }
                        <th class="col-percentual">%</th>
                    </tr>
                </thead>
                <tbody>
                    @for (membro of membros(); track membro.idSolicitante) {
                        <tr>
                            <td class="col-membro col-sticky" [class.membro-coordenador]="membro.coordenador">
                                <span class="membro-nome">{{ membro.nome }}</span>
                                <span class="membro-participacao">{{ membro.dsParticipacao }}</span>
                            </td>
                            @for (reuniao of reunioes(); track reuniao.idReuniao) {
                                <td class="col-reuniao" [ngClass]="classePresenca(obterPresenca(membro, reuniao.idReuniao))" [title]="tituloPresenca(obterPresenca(membro, reuniao.idReuniao))">
                                    {{ rotuloPresenca(obterPresenca(membro, reuniao.idReuniao)) }}
                                </td>
                            }
                            <td class="col-percentual">{{ percentualMembro(membro) }}</td>
                        </tr>
                    }
                </tbody>
                <tfoot>
                    <tr>
                        <td class="col-membro col-sticky">Quórum</td>
                        @for (reuniao of reunioes(); track reuniao.idReuniao) {
                            <td class="col-reuniao col-quorum" [title]="reuniao.totalPresentes + ' de ' + reuniao.totalMembros + ' membros'">{{ formatarPercentual(reuniao.percentualQuorum) }}</td>
                        }
                        <td class="col-percentual"></td>
                    </tr>
                </tfoot>
            </table>
        </div>

        <div class="matriz-legenda" aria-label="Legenda de presença">
            @for (item of legenda; track item.sigla) {
                <span class="legenda-item">
                    <span class="legenda-cor" [ngClass]="item.classe"></span>
                    <span class="legenda-texto"
                        ><strong>{{ item.sigla }}</strong> — {{ item.descricao }}</span
                    >
                </span>
            }
        </div>
    </div>
} @else {
    <div class="matriz-vazio">
        <i class="pi pi-calendar-times"></i>
        <span>Sem reuniões no período selecionado.</span>
    </div>
}
